import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { NursingReferralList } from '../interfaces/nursing-referrals-list';
import { catchError, Observable } from 'rxjs';
import { handleError } from 'src/app/shared/functions/error-handler';
import { NursingReferralRequest } from '../models/nursing-referral-request.model';
import { NursingStudentData } from '../interfaces/nursing-student-data';
import { INursingReferralStatus } from 'src/app/shared/interfaces/nursing-status';
import { IPayloadDocUpload } from '../interfaces/document-upload-payload';

@Injectable({
  providedIn: 'root',
})
export class NursingReferralService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  //   dataList = [
  //   {
  //     "caseActionSk": "d4d54dc8-3a0e-412c-850b-63e86716e2a8",
  //     "studentName": "string",
  //     "nycId": "925219313",
  //     "grade": 0,
  //     "studentDOB": "string",
  //     "schoolDBN": "string",
  //     "schoolName": "string",
  //     "schoolBorough": "string",
  //     "schoolDistrict": "string",
  //     "schoolCSE": "string",
  //     "referralType": "",
  //     "statusName": "Draft",
  //     "lastModified": "2025-08-28T23:24:02.187",
  //     "daysago": "0 days ago"
  //   },
  //   {
  //     "caseActionSk": "d4d54dc8-3a0e-412c-850b-63e86716e2a8",
  //     "studentName": "string",
  //     "nycId": "925219313",
  //     "grade": 0,
  //     "studentDOB": "string",
  //     "schoolDBN": "string",
  //     "schoolName": "string",
  //     "schoolBorough": "string",
  //     "schoolDistrict": "string",
  //     "schoolCSE": "string",
  //     "referralType": "",
  //     "statusName": "Draft",
  //     "lastModified": "2025-08-20T15:14:56.223",
  //     "daysago": "8 days ago"
  //   }
  // ];

  public referralsList(): Observable<NursingReferralList[]> {
    return this.http
      .get<NursingReferralList[]>(`${this.config.apiUrl}/NursingReferral/List`)
      .pipe(catchError(handleError));
  }

  public get(caseActionSk: string): Observable<NursingReferralRequest> {
    return this.http
      .get<NursingReferralRequest>(
        `${this.config.apiUrl}/NursingReferral/${caseActionSk}`
      )
      .pipe(catchError(handleError));
  }

  public getStudentData(nycId: string): Observable<NursingStudentData> {
    return this.http
      .get<NursingStudentData>(
        `${this.config.apiUrl}/NursingReferral/studentDetailes/${nycId}`
      )
      .pipe(catchError(handleError));
  }

  public removeNursingReferral(caseActionSk: string): Observable<boolean> {
    return this.http
      .delete<boolean>(
        `${this.config.apiUrl}/NursingReferral/DeleteNursingReferral/${caseActionSk}`
      )
      .pipe(catchError(handleError));
  }
  public AddNursingReferral(payload: any): Observable<NursingReferralRequest> {
    return this.http
      .post<NursingReferralRequest>(
        `${this.config.apiUrl}/NursingReferral/AddNursingReferral`,
        payload
      )
      .pipe(catchError(handleError));
  }
  public getStatus(iepFormSk: string): Observable<INursingReferralStatus> {
    return this.http
      .get<INursingReferralStatus>(
        `${this.config.apiUrl}/NursingReferral/Status/${iepFormSk}`
      )
      .pipe(catchError(handleError));
  }

  updateDocumentMetaData(payload: IPayloadDocUpload[]): Observable<true> {
    return this.http
      .post<true>(`${this.config.apiUrl}/NursingReferral/updateDocumentMetadata`, payload)
      .pipe(catchError(handleError));
  }

  cancelReferral(payload: { caseactionSK:string}): Observable<boolean> {
    return this.http
      .put<boolean>(
        `${this.config.apiUrl}/NursingReferral/CancelNursingReferral`,
        payload
      )
      .pipe(catchError(handleError));
  }
}
